import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScLeaveRegistration = styled.div`
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  width: 100%;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  border-radius: 24px;
  box-sizing: border-box;
  padding: 32px;

  .emoji-img {
    margin-bottom: 32px;
  }

  .title {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    margin-bottom: 12px;
    text-align: center;
  }

  .leaving-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    width: 100%;
    padding-bottom: 32px;
  }

  .buttons {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 0 10px;
  }

  @media (${device.mobileS}) {
    max-width: calc(100% - 16px);
    padding: 16px;
  }
`;
